<template>
  <div class="rate-period-container">
    <table style="border: none; table-layout:fixed" width="100%">
      <tr>
        <td style="width: 300px; vertical-align: bottom; padding-bottom: 15px">
          <el-row
            v-for="(period, index) in periodList" :key="index">
            <el-col :span="4" style="text-align: right; padding-right: 10px">
              <label v-if="index === 0" style="font-size: 14px; color: #606266">{{ $t('period') }}</label>
              <label v-if="index > 0"><i class="el-icon-remove" style="color: red" @click="onRemovePeriodButtonClick(index)"></i></label>
            </el-col>
            <el-col :span="20">
              <el-date-picker size="small"
                              v-model="periodList[index]"
                              type="daterange"
                              format="d MMM yyyy"
                              value-format="yyyy-MM-dd"
                              start-placeholder="From"
                              end-placeholder="To"
                              @change="periodChange(index)">
              </el-date-picker>
            </el-col>
          </el-row>
        </td>
        <td style="position: relative">
          <div class="allotment-panel-cover-head"></div>
          <div class="allotment-panel">
            <el-row>
              <el-col :span="24" style="text-align: right; padding-right: 10px">
                <el-dropdown v-if="filterRoomTypeList().length > 0"
                             @command="onAddRoomPriceButtonClick"
                             style="margin-right: 10px">
                  <el-button type="default" size="mini">
                    <i class="el-icon-plus"></i>
                    {{ $t('addRoom') }}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-for="(roomType, roomTypeIndex) in filterRoomTypeList()"
                      :key="roomTypeIndex"
                      :command="roomType.id">
                      {{ (roomType.isEnable === STATUS.ENABLE) ? '' : `[${$t('STATUS.DISABLE')}]` }} {{roomType.name}}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <el-button type="default"
                           size="mini"
                           @click="goToLeft()"
                           style="padding: 7px 7px">
                  <i class="el-icon-arrow-left"></i>
                </el-button>
                <el-button type="default"
                           size="mini"
                           @click="goToRight()"
                           style="padding: 7px 7px">
                  <i class="el-icon-arrow-right"></i>
                </el-button>
              </el-col>
            </el-row>
            <div class="allotment-container"
                 ref="divRoomsRateCode"
                 id="divRoomsRateCode">
              <table style="vertical-align: bottom;">
                <tr>
                  <td v-for="roomTypeId of selectRoomTypeList"
                      :key="roomTypeId"
                      class="room-type-column">
                    <table cellpadding="0" cellspacing="0" border="0">
                      <tr>
                        <td valign="bottom"
                            style="width: 20px; vertical-align: bottom">
                          <i class="el-icon-remove"
                             style="color: red"
                             @click="onRemoveRoomTyeButtonClick(roomTypeId)"></i>
                        </td >
                        <td :class="{ disable: isDisableRoomType(roomTypeId)}"
                            style="font-size: 11px;">
                          {{ getRoomTypeName(roomTypeId) }}
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
              <div  v-for="(period, index) in periodList" :key="index"
                   style="margin-top: 8px">
                <table cellpadding="0" cellspacing="0">
                  <tr>
                    <td v-for="(roomTypeId) in selectRoomTypeList" :key="`${roomTypeId}-${index}`"
                        class="room-type-column">
                      <div class="el-input el-input--small">
                        <input placeholder="-"
                               type="number"
                               class="room-price el-input__inner"
                               @input="roomPriceChange()"
                               v-model="roomPriceList[roomTypeId][index]" />
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div class="allotment-panel-cover-bottom"></div>
        </td>
      </tr>
      <tr>
        <td>
          <el-row>
            <el-col :span="4"> &nbsp;</el-col>
            <el-col :span="20">
              <el-button plain
                         type="primary"
                         @click="onAddPeriodButtonClick"
                         size="mini"
                         style="width: 100%">
                <i class="el-icon-plus"></i>
                {{ $t('addPeriod') }}
              </el-button>
            </el-col>
          </el-row>
        </td>
        <td>
          &nbsp;
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { STATUS } from '@/configs/constant'
import i18nMessages from '@/translations/Hotel/ManageHotel/RateCode/Edit.i18n'
import { getISODateFormat, periodOverlap, getValidPeriodList, preparePeriodList } from '@/helpers/index'
import { sortPeriodList } from '@/helpers/datetime'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import { get } from 'lodash'

export default {
  name: 'RateCodePeriodList',
  mixins: [AlertViewMixin],
  components: {},
  i18n: { messages: i18nMessages },
  model: {
    prop: 'rateCodeDetailList',
    event: 'onRateCodeDetailChange'
  },
  props: {
    roomTypeList: Array,
    rateCodeDetailList: Array
  },
  created: function () {
    this.prepareRoomTypeListById()
    this.prepareRatePeriodListData()
  },
  data () {
    return {
      STATUS,
      periodList: [''],
      roomPriceList: {},
      roomTypeListById: {},
      selectRoomTypeList: []
    }
  },
  methods: {
    getRoomTypeName: function (roomTypeId) {
      const roomTypeName = get(this.roomTypeListById, `[${roomTypeId}].name`, '[Deleted]')

      return roomTypeName
    },
    isDisableRoomType: function (roomTypeId) {
      const roomTypeStatus = get(this.roomTypeListById, `[${roomTypeId}].isEnable`, STATUS.DISABLE)

      return (roomTypeStatus === STATUS.DISABLE)
    },
    roomPriceChange: function () {
      const rateCodeDetailList = this.getRateCodeDetailList()
      this.$emit('onRateCodeDetailChange', rateCodeDetailList)
    },
    periodChange: function (index) {
      const periodList = getValidPeriodList(this.periodList)
      const newPeriodList = preparePeriodList(periodList)

      if (periodOverlap(newPeriodList) === true) {
        const message = this.$t('alertOverlap')
        this.alertError(message)
        this.periodList[index][0] = ''
        this.periodList[index][1] = ''
      }

      const rateCodeDetailList = this.getRateCodeDetailList()
      this.$emit('onRateCodeDetailChange', rateCodeDetailList)
    },
    prepareRoomTypeListById: function () {
      for (let index in this.roomTypeList) {
        const roomTypeId = this.roomTypeList[index].id
        this.roomTypeListById[roomTypeId] = this.roomTypeList[index]
      }
    },
    prepareRatePeriodListData: function () {
      const periodKeyList = []
      const roomTypeIdList = []
      const roomTypeItemList = []
      const rateCodeDetailList = [ ...this.rateCodeDetailList ]
      let index = 0

      rateCodeDetailList.sort(sortPeriodList)
      for (let rateCodeDetail of rateCodeDetailList) {
        const startDate = getISODateFormat(new Date(rateCodeDetail.startDate))
        const endDate = getISODateFormat(new Date(rateCodeDetail.endDate))
        const roomTypeId = rateCodeDetail.roomTypeId
        const price = rateCodeDetail.price
        const periodKey = `${startDate}_${endDate}`
        const isIncludePeriod = periodKeyList.includes(periodKey)

        if (!roomTypeIdList.includes(roomTypeId)) {
          const roomTypeName = get(this.roomTypeListById, `[${roomTypeId}].name`, '')
          const roomTypeItem = {
            id: roomTypeId,
            name: roomTypeName
          }

          roomTypeItemList.push(roomTypeItem)
        }

        if (this.roomPriceList[roomTypeId] === undefined) {
          this.roomPriceList[roomTypeId] = []
        }

        if (!isIncludePeriod) {
          this.periodList[index] = [ startDate, endDate ]
          this.roomPriceList[roomTypeId][index] = price

          periodKeyList.push(periodKey)
          index++
        } else {
          const periodIndex = periodKeyList.indexOf(periodKey)
          this.roomPriceList[roomTypeId][periodIndex] = price
        }
      }
      const roomTypeItemSorted = roomTypeItemList.sort((a, b) => {
        return (a.name < b.name) ? -1 : 1
      })

      this.selectRoomTypeList = [...new Set(roomTypeItemSorted.map(a => a.id))]
    },
    onAddPeriodButtonClick: function () {
      this.periodList.push('')

      for (let roomTypeId of this.selectRoomTypeList) {
        this.roomPriceList[roomTypeId].push('')
      }
    },
    onAddRoomPriceButtonClick: function (roomTypeId) {
      this.selectRoomTypeList.push(roomTypeId)
      this.roomPriceList[roomTypeId] = new Array(this.periodList.length).fill('')
    },
    onRemoveRoomTyeButtonClick: function (roomTypeId) {
      const index = this.selectRoomTypeList.indexOf(roomTypeId)
      this.selectRoomTypeList.splice(index, 1)

      delete this.roomPriceList[roomTypeId]

      this.roomPriceChange()
    },
    onRemovePeriodButtonClick: function (index) {
      this.periodList.splice(index, 1)

      for (let roomTyeId in this.roomPriceList) {
        this.roomPriceList[roomTyeId].splice(index, 1)
      }

      this.roomPriceChange()
    },
    filterRoomTypeList: function () {
      const filterRoomType = this.roomTypeList.filter((roomType) => {
        if (this.selectRoomTypeList.indexOf(roomType.id) > -1) {
          return false
        }

        return true
      })

      return filterRoomType.sort((a, b) => {
        return (a.name > b.name) ? 1 : -1
      })
    },
    getRateCodeDetailList: function () {
      const rateDetailList = []

      for (let periodIndex in this.periodList) {
        if (this.periodList[periodIndex][0] !== undefined && this.periodList[periodIndex][1] !== undefined) {
          const startDate = this.periodList[periodIndex][0]
          const endDate = this.periodList[periodIndex][1]

          for (let roomTypeId in this.roomPriceList) {
            if (this.roomPriceList[roomTypeId][periodIndex] !== undefined) {
              const price = Number(this.roomPriceList[roomTypeId][periodIndex])

              if (price > 0) {
                const rateDetail = {
                  startDate: startDate,
                  endDate: endDate,
                  price: Number(this.roomPriceList[roomTypeId][periodIndex]),
                  roomTypeId: roomTypeId
                }

                rateDetailList.push(rateDetail)
              }
            }
          }
        }
      }

      return rateDetailList
    },
    goToRight: function () {
      this.$refs.divRoomsRateCode.scrollLeft += 100
    },

    goToLeft: function () {
      this.$refs.divRoomsRateCode.scrollLeft -= 100
    }
  }
}
</script>

<style scoped>
  .el-form > div {
    text-align: left;
  }

  .rate-period-container {
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    padding-left: 50px;
    padding-bottom: 20px;
  }

  .el-date-editor--daterange.el-input__inner {
    width: 100%;
  }

  .room-price.el-input__inner {
    text-align: right;
    padding: 0px !important;
  }

  .room-type-group {
    max-width: 90px;
    min-width: 75px;
    padding-left: 10px;
  }
  .disable {
    color: #d2d1d1;
  }
  .room-type-column {
    max-width: 90px;
    min-width: 90px;
    vertical-align: bottom;
    padding-left: 10px;
  }

  .allotment-panel{
    margin: 0px 20px;
    padding-top: 20px;
    box-shadow:  0px 0px 7px rgba(0,0,0,0.2);
    overflow: hidden;
  }

  .allotment-container {
    overflow-x: scroll;
    border-top-width: 0px;
    border-bottom-width: 0px;
    padding-bottom: 20px;
  }

  .allotment-panel-cover-head {
    position: absolute;
    top: -2px;
    left: 0px;
    width: 100%;
    height: 15px;
    z-index: 3;
    background-color: rgb(255, 255, 255);
  }

  .allotment-panel-cover-bottom {
    position: absolute;
    bottom: -15px;
    left: 0px;
    width: 100%;
    height: 17px;
    z-index: 3;
    background-color: rgb(255, 255, 255);
  }
</style>
